export default __webpack_public_path__ + "static/media/evento_transferencia_masivo.a4485074.xlsx";